// 本地数据存储的key
const SESSION_KEY = 'XITO_USER_IFON';
// 软件id(识别桌面/移动设备)
const APP_ID = 'eb4dd4e5488df8d37d0d0f3b013556e8';
// 东区接口
const EAST_API = 'https://gadgahad.xitohere.com';
const EAST_PIC_API = 'https://gahaf.xitohere.com';
// 西区接口
const WEST_API = 'https://waga.xitohere.com';
const WEST_PIC_API = 'https://wagaf.xitohere.com';
// 东区token
const EAST_ACCESS_TOKEN = 'MDAwMDAwMDAwMIWMppazzM3WvKy2ZrJ1wM6-m4Wpko63r352j6p-r3jLhXyj0cDMs9ywrM2fvnWzlb2FfaWGi7ttf4aDY355j9mEn56i';
// 西区token
//const EAST_ACCESS_TOKEN = 'MDAwMDAwMDAwMIV8zJmzzMnWsXamrbOIvM6yeJKbk4vFaoqciJt-eZ2WkI-z0bTPvMuxdrJosauwz7KriaWGi7uxgHaDZn2fi5WEeZ6i';

const WEST_ACCESS_TOKEN = 'MDAwMDAwMDAwMIV8zJmzzMnWsXamrbOIvM6yeJKbk4vFaoqciJt-eZ2WkI-z0bTPvMuxdrJosauwz7KriaWGi7uxgHaDZn2fi5WEeZ6i';
// 支付密钥 pro pk_live_dbfBnEidvsBfJfUkY0V0wiy1002ZNHJeox    dev pk_test_7hSrFkHddebKkQNu6bZAvLez00NWJPaqqj
const STRIPE_KEY_xito = process.env.NODE_ENV === 'production' ? 'pk_live_dbfBnEidvsBfJfUkY0V0wiy1002ZNHJeox' : 'pk_test_7hSrFkHddebKkQNu6bZAvLez00NWJPaqqj';
const STRIPE_KEY_tian = process.env.NODE_ENV === 'production' ? 'pk_live_51N6OuTJCI5eKVzjJDOkMzWtrIQqltfZOZRDuGuwu64QXH7w4OXBR0wDEdrIanubWjLG4a0zx2oLalt6mVQ8nsQbl005QpwrsOw' : 'pk_test_7hSrFkHddebKkQNu6bZAvLez00NWJPaqqj';

// 是否需要登录
const NEED_LOGIN = false;
// 口令、邮箱弹窗中是否要验证手机号码
const VERIFY_MOBILE = false;

function getSiteData() {
	const data = Object.create(null);
	// 网址分解
	const { host, href, origin, search, hostname, pathname } = window.location;
	// 网址主机
	data['HOST'] = host;
	// 网址全称
	data['HREF'] = href;
	// 网址源头
	data['ORIGIN'] = origin;
	// 网址主机名
	data['HOSTNAME'] = hostname;
	// 网址路径名
	data['PATHNAME'] = pathname;
	// 网址搜索参数
	data['SEARCH'] = href.indexOf('?') > -1 ? href.substring(href.indexOf('?')) : '';
	data['SEARCH'] = data['SEARCH'] === '?' ? '' : data['SEARCH'];
	// 网址去掉参数
	data['URL'] = href.replace(data['SEARCH'], '');
	// 网址参数
	data['QUERY'] = Object.create(null);
	// 生成对象模式
	if (href.indexOf('?') > -1) {
		// for (let [ key, value ] of search.substring(search.indexOf('?') + 1).split('&').filter(Boolean).map(v => v.split('=').filter(Boolean)) ) {
		// for (let [ key, value ] of hash.substring(hash.indexOf('?') + 1).split('&').filter(Boolean).map(v => v.split('=').filter(Boolean)) ) {
		for (let [ key, value ] of href.substring(href.indexOf('?') + 1).split('&').filter(Boolean).map(v => v.split('=').filter(Boolean)) ) {
			if (key) {
				data['QUERY'][ key ] = value || '';
			}
		}
	}
	return data;
}

function getFileData(path = '') {
	return new Promise((resolve, reject) => {
		try {
			const xhr = new XMLHttpRequest();
			xhr.open('GET', path, true);
			xhr.onreadystatechange = function() {
			    if (xhr.readyState == 4) {
			        if (xhr.status == 200) {
			            let data = xhr.responseText;
			            try {
			            	data = JSON.parse(xhr.responseText);
			            } catch(err) {
			                data = xhr.responseText;
			                // 如果是.js文件
			                if (path.substring(path.length - 3) === '.js') {
			                    data = data.replace('export default', '');
								try {
									data = eval(data) || Object.create(null);
								} catch (err) {
									data = '';
								}
			                } else {
								data = '';
							}
			            }
			            resolve({
			                status: 'success',
			                data: data || Object.create(null)
			            });
			        } else {
			            reject();
			        }
			    }
			}
			xhr.send(null);
		} catch (err) {
			reject();
		}
	});
}

function textFavicon(path = '') {
	return new Promise(resolve => {
	  let imageElement = new Image();
	  let data = Object.create(null);
	  data['status'] = 'error';
	  data['height'] = 0;
	  data['width'] = 0;
	  data['type'] = 'image';
	  data['url'] = path;
	  imageElement.addEventListener('load', function() {
	    data['height'] = Math.round(this.height * 100) / 100;
	    data['width'] = Math.round(this.width * 100) / 100;
	    data['status'] = 'success';
	    imageElement = null;
	    resolve(data);
	  });
	  imageElement.addEventListener('error', function() {
	    imageElement = null;
	    resolve(data);
	  });
	  imageElement.src = path;
	  // imageElement.load(); // 图片对象没有load事件
	});
}

export default async function() {
	const config = getSiteData();
	config.HOSTNAME = process.env.NODE_ENV === 'development' ? 'pager.vauther.com' : config.HOSTNAME;
	config['APP_ID'] = APP_ID;
	config['STRIPE_KEY_xito'] = STRIPE_KEY_xito;
	config['STRIPE_KEY_tian'] = STRIPE_KEY_tian;
	config['SESSION_KEY'] = SESSION_KEY; 
	config['needLogin'] = NEED_LOGIN;
	config['verifyMobile'] = VERIFY_MOBILE;
	config['title'] = '';
	config['region'] = 'west';
	config['favicon'] = config.HOSTNAME + '.ico';
	config['content'] = null;
	config['libraryId'] = '';
	config['rootDomain'] = config.HOSTNAME;
  
	if (config.SEARCH && config.QUERY['p_id'] && isNaN(config.QUERY['p_id']) === false && Number(config.QUERY['p_id']) > 0) {
	  const searchParams = config.SEARCH.split('&');
	  for (let param of searchParams) {
		if (param.includes('p_id=')) {
		  config['libraryId'] = param.split('p_id=')[1].split('#')[0];
		  console.log(config['libraryId'])
		  break;
		}
		
	  }
	} else {
	  try {
		// Using Promise.race to introduce a timeout
		const timeout = ms => new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), ms));
		const { status, data } = await Promise.race([getFileData('pager'+config.HOSTNAME + '.o'), timeout(5000)]);
  
		if (status === 'success' && data.rootDomain === config.HOSTNAME && data.subs && data.subs.length) {
		  const index = data.subs.findIndex(item => item.domainOrigin === config.SEARCH);
		  console.log(JSON.parse(JSON.stringify(data)));
		  
		  if (index > -1) {
			config['title'] = data.title || '';
			config['region'] = data.region || 'west';
			for (let key in data.subs[index]) {
			  config[key] = data.subs[index][key];
			}
		  } else {
			const defaultFile = await Promise.race([getFileData('404.o'), timeout(5000)]);
			if (defaultFile.status === 'success') {
			  config['title'] = '404';
			  config['favicon'] = '404.ico';
			  config['content'] = defaultFile.data;
			  config['libraryId'] = config.content.phamula_id;
			}
		  }
		}
	  } catch (error) {
		console.error('Error loading file data:', error);
	  }
	}
	// New logic for r parameters
	if (config.SEARCH && config.QUERY['r']) {
	const rValues = Array.isArray(config.QUERY['r']) ? config.QUERY['r'] : [config.QUERY['r']];
	rValues.forEach((value, index) => {
		if (index === 0) {
		config['route'] = value;
		console.log(`pagetag: ${value}`);
		} else {
		config[`pagetag${index + 1}`] = value;
		console.log(`pagetag${index + 1}: ${value}`);
		}
	});
	}

	// Optional: Handle cases where 'r' parameter is not present
	if (!config.QUERY['r']) {
	config['pagetag'] = null; // or any default value you'd prefer
	}
  
	if (config['title']) {
	  document.title = config['title'];
	}
	if (config['favicon']) {
	  const iconFile = await textFavicon(config['favicon']);
	  if (iconFile.status === 'success') {
		document.querySelector('link[rel=icon]').href = config['favicon'];
	  }
	}
  
	config['API'] = config['region'] === 'west' ? WEST_API : EAST_API;
	config['PIC_API'] = config['region'] === 'west' ? WEST_PIC_API : EAST_PIC_API;
	config['ACCESS_TOKEN'] = config['region'] === 'west' ? WEST_ACCESS_TOKEN : EAST_ACCESS_TOKEN;
  
	console.log('\n')
	console.log(config)
	console.log('\n')
	return config;
  }